import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider } from '@backstage/theme';
import DarkIcon from '@material-ui/icons/Brightness2';
import LightIcon from '@material-ui/icons/WbSunny';
import { createTomTomTheme } from './createTomTomTheme';
import './theme.css';

const lightTheme = createTomTomTheme('light');
const darkTheme = createTomTomTheme('dark');

// Named `light` and `dark` so they replace the built-in `theme:app/light` and
// `theme:app/dark`, which keeps every user's stored theme choice valid.
const tomtomLightTheme = ThemeBlueprint.make({
  name: 'light',
  params: {
    theme: {
      id: 'light',
      title: 'Light Theme',
      variant: 'light',
      icon: <LightIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={lightTheme} themeName="tomtom">
          {children}
        </UnifiedThemeProvider>
      ),
    },
  },
});

const tomtomDarkTheme = ThemeBlueprint.make({
  name: 'dark',
  params: {
    theme: {
      id: 'dark',
      title: 'Dark Theme',
      variant: 'dark',
      icon: <DarkIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={darkTheme} themeName="tomtom">
          {children}
        </UnifiedThemeProvider>
      ),
    },
  },
});

export const tomtomThemeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [tomtomLightTheme, tomtomDarkTheme],
});
